import { applyMiddleware, createStore } from "redux";
import thunkMiddleware from 'redux-thunk';
import { database } from '../database/config';
import { ref, onValue } from 'firebase/database';

const SHOW_TOOLS = 'SHOW_TOOLS';
const FILTER_TOOLS = 'FILTER_TOOLS';
const FIND_TOOLS = 'FIND_TOOLS';
const DATABASE_REF = ref(database);

let allTools = {}

const toolsReducer = (state = [], action) => {
    let result = []
	switch (action.type) {
		case SHOW_TOOLS:
            result = action.subcategory ? [...action.payload[action.category][action.subcategory]]:
            [...action.payload[action.category]]
            return result
        case FILTER_TOOLS:
            result = action.subcategory ? [...action.payload[action.category][action.subcategory].filter(item => item.brand === action.brand)]:
            [...action.payload[action.category].filter(item => item.brand === action.brand)]
            return result
        case FIND_TOOLS:
            result = []
            for(let item in action.payload){
                if(action.payload[item] instanceof Array){
                    result = [...result,...action.payload[item].filter(i => i.title.toLowerCase().includes(action.title))]
                }else{
                    for (let key in action.payload[item]) {
                        result = [...result,...action.payload[item][key].filter(i => i.title.toLowerCase().includes(action.title))]
                    }
                }
            }
            return result
		default:
			return state;
	}
}

export function findTools (title) {
    return{
        type: FIND_TOOLS,
        payload: allTools,
        title: title.toLowerCase()
    }
}

export function filterTools (category, subcategory, brand){
    return{
        type: FILTER_TOOLS,
        payload: allTools,
        category: category,
        subcategory: subcategory,
        brand: brand
    }
}

export function showTools (category, subcategory) { 
    return {
        type: SHOW_TOOLS,
        payload: allTools,
        category: category,
        subcategory: subcategory
    }
}

export function fetchTop (){
    return (dispatch) => {
        onValue(DATABASE_REF, (snap) => {
            allTools = snap.val()
            dispatch(showTools('top',''))
        })
	}
}
export function fetchTools (findTool) {
	return (dispatch) => {
        onValue(DATABASE_REF, (snap) => {
            allTools = snap.val()
            
            if(findTool){
                dispatch(findTools(decodeURI(findTool)))
            }else{
                dispatch(showTools('stroitelnie_smesi','shtukaturka'))
            }
        })
	} 
}

export default toolsReducer